<template>
  <div style="min-height: 92vh">
    <div>
      <h3>Productos</h3>
      <uv-data-table :config="config" :data="global_prod" :pageRows="15" @buttonClick="dtButtonClick"></uv-data-table>
    </div>
    <modal v-model="showModal" :showFooter="false" title="Productos">
      <ProductosForm :edit="editMode" :key="formIndex" @toggle="toggleModal" :dataEdit="editData"
        @successData="successData">
      </ProductosForm>
    </modal>
    <modal v-model="showModalModificador" :showFooter="false" title="Modificadores Productos">
      <ProductosModificadores :edit="editMode" :key="formIndex" @toggle="showModalModificador = false"
        :dataEdit="editData" @successData="saveModificadores" />
    </modal>
    <modal v-model="showModalPrecio" :showFooter="false" title="Modificar Precios">
      <ProductoPrecioForm :edit="editMode" :key="formIndex" @toggle="showModalPrecio = false" :dataEdit="editData">
      </ProductoPrecioForm>
    </modal>
    <modal v-model="showModalPrecioPorcentaje" :showFooter="false" title="Modificar Precios">
      <ProductoPrecioProcentajeForm :edit="editMode" :key="formIndex" @toggle="showModalPrecioPorcentaje = false"
        :dataEdit="editData">
      </ProductoPrecioProcentajeForm>
    </modal>
  </div>
</template>

<style></style>

<script>
import modal from "../../MainComponents/modal.vue";
import uvDataTable from "../../MainComponents/DataTable.vue";
import ProductosForm from "../Productos/ProductosForm.vue";
import ProductoPrecioForm from "../Productos/ProductoPrecioForm.vue";
import ProductoPrecioProcentajeForm from "../Productos/ProductoPrecioPorcentajeForm.vue";
import ProductosModificadores from "../Productos/ProductosModificadores.vue";
import { mapActions } from "vuex";
export default {
  name: "ProductosCRUD",
  components: {
    modal,
    uvDataTable,
    ProductosForm,
    ProductoPrecioForm,
    ProductoPrecioProcentajeForm,
    ProductosModificadores,
  },
  props: [],
  data() {
    return {
      MainDepartamento: "",
      self: this,
      showModal: false,
      formKey: 0,
      formIndex: 0,
      editMode: false,
      familias: [],
      Categories: [],
      editData: [],
      products: [],
      showModalPrecio: false,
      showModalModificador: false,
      showModalPrecioPorcentaje: false,
      showModalRecetas: false,
      zonas: [],
      config: {
        selectableRow: true,
        orderByCol: { Field: "", Type: "Asc" },
        allowExport: true,
        rawText: "Productos",
        selectConfig: {
          idRowData: "id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        buttons: [
          {
            text: "Agregar",
            icon: "lni lni-plus",
            buttonId: "addProducto",
          },
          {
            text: "Editar",
            icon: "lni lni-pencil-alt",
            buttonId: "editProducto",
            require: true,
          },
          {
            text: "Eliminar",
            icon: "lni lni-trash",
            buttonId: "deleteProducto",
            require: true,
          },
          {
            text: "Modificar Precio",
            icon: "lni lni-dollar",
            buttonId: "editPrecio",
            require: true,
          },
          {
            text: "+/- % Precio",
            icon: "",
            buttonId: "editPrecioMasivo",
            require: false,
          },
          {
            text: "Admin. Modificadores",
            icon: "lni lni-list",
            buttonId: "adminModificadores",
            require: true,
          },
          /* {
            text: "Admin. Receta",
            icon: "lni lni-list",
            buttonId: "adminIngredientes",
            require: true,
          },*/
        ],
        fields: [
          {
            text: "Nombre",
            value: "Nombre",
          },
          {
            text: "Marca",
            value: "Marca",
            canBeFiltered: true,
          },
          {
            text: "Codigo",
            value: "Codigo",
          },
          {
            text: "Tipo",
            value: "Tipo",
            canBeFiltered: true,
          },
          {
            text: "Categoria",
            value: "categoria_name",
            canBeFiltered: true,
          },
          {
            text: "Zona impresión",
            value: "ZImp",
            canBeFiltered: true,
          },
          {
            canBeFiltered: true,
            text: "Familia",
            value: "Familia",
          },
          {
            text: "Departamentos",
            value: "Departamentos",
            canBeFiltered: true,
          },
          {
            text: "Existencia",
            value: "existenciaData", //'Existencia',
            format: (row) => {
              let html = "";
              row["existenciaData"].forEach((element) => {
                html +=
                  "<span>&#8226;</span> " +
                  element.NombreOrigen +
                  ": " +
                  element.Price.Stock +
                  "<br/>";
              });
              return html;
            },
          },
          {
            text: "Precio",
            value: "existenciaPrecio",
            format: (row) => {
              let html = "";
              if (row["Tipo"] == "Producto-NInv") {
                return row["Precio"] + " " + row["Moneda"];
              } else {
                row["existenciaPrecio"].forEach((element) => {
                  html +=
                    "<span>&#8226;</span> " +
                    element.NombreOrigen +
                    ": " +
                    this.$pgsHelper.formatNumber(element.Price.PV) +
                    " " +
                    this.$Currencies.getCurrencyDefault() +
                    " <br/>";
                });
              }

              return html;
              //return '$'+row['Precio']+' '+row['Moneda']+'';
            },
          },
          {
            text: "Costo",
            value: "existenciaCosto",
            format: (row) => {
              let html = "";
              if (row["Tipo"] == "Producto-NInv") {
                return "N/A";
              } else {
                row["existenciaCosto"].forEach((element) => {
                  html +=
                    "<span>&#8226;</span> " +
                    element.NombreOrigen +
                    ": " +
                    this.$pgsHelper.formatNumber(element.Price.PCP) +
                    " " +
                    this.$Currencies.getCurrencyDefault() +
                    " <br/>";
                });
              }

              return html;
              //return '$'+row['Precio']+' '+row['Moneda']+'';
            },
          },
        ],
      },
    };
  },
  methods: {
    dtButtonClick(buttonId, idSelected) {
      if (buttonId == "addProducto") {
        this.formIndex++;
        this.editMode = false;
        this.editData = {};
        this.$pgsHelper.log(this.editData);
        this.showModal = true;
      }
      if (buttonId == "editProducto") {
        this.formIndex++;
        this.editMode = true;
        this.editData = this.getProductoById(idSelected[0]);
        this.$pgsHelper.log(this.editData);
        this.showModal = true;
      }
      if (buttonId == "editPrecio") {
        this.formIndex++;
        this.editMode = true;
        this.editData = this.getProductoById(idSelected[0]);
        this.showModalPrecio = true;
      }
      if (buttonId == "deleteProducto") {
        this.deleteProducto(idSelected[0]);
      }
      if (buttonId == "editPrecioMasivo") {
        this.formIndex++;
        this.editMode = false;
        this.editData = {};
        this.showModalPrecioPorcentaje = true;
      }
      if (buttonId == "adminModificadores") {
        this.formIndex++;
        this.editMode = true;
        this.editData = this.$pgsHelper.getById(
          this.global_prod,
          "id",
          idSelected[0]
        );
        this.showModalModificador = true;
      }
      if (buttonId == "adminIngredientes") {
        this.formIndex++;
        this.editMode = true;
        this.editData = this.$pgsHelper.getById(
          this.global_prod,
          "id",
          idSelected[0]
        );
        this.showModalRecetas = true;
      }
    },
    successData(data, doAction) {
      data.Precio = parseFloat(data.Precio);
      data.Orden = Number(data.Orden);
      if (doAction == "CREATE") {
        this.addProduct(data);
      } else if (doAction == "EDIT") {
        this.editProduct(data);
      }
    },
    async deleteProducto(id) {
      const deletedObject = this.getProductoById(id) || { Id: id };
      let datos = { Id: id };
      this.$alert.alertConfirm({
        action: "eliminar",
        obj: "el producto",
        route: "PDV-Productos-deleteProducto",
        data: datos,
        onSuccess: () => {
          this.$pgsHelper.writeLog({
            Evento: "PRODUCTO_DELETE",
            Mensaje: "Producto eliminado ",
            reference: { id: id, tp: "Producto", al: "Producto General" },
            data: deletedObject
          });
          this.getCategories();
        },
      });
    },
    editProduct(datos) {
      //datos.Departamento      =  this.MainDepartamento;
      this.$alert.alertConfirm({
        action: "editar",
        obj: "el producto",
        route: "PDV-Productos-updateProducto",
        data: datos,
        onSuccess: () => {
          this.$pgsHelper.writeLog({
            Evento: "PRODUCTO_EDIT",
            Mensaje: "Producto editado",
            reference: { id: datos.id, tp: "Producto", al: "Producto General" },
            data: datos
          });
          this.toggleModal(false);
        },
      });
    },
    addProduct(datos) {
      this.$alert.alertConfirm({
        action: "crear",
        obj: "el producto",
        route: "PDV-Productos-createProducto",
        data: datos,
        onSuccess: (result) => {
          const targetId = result?.data?.id || result?.data?.data?.id || datos.id;
          this.$pgsHelper.writeLog({
            Evento: "PRODUCTO_CREATE",
            Mensaje: "Producto creado",
            reference: { id: targetId, tp: "Producto", al: "Producto General" },
            data: datos
          });
          this.toggleModal(false);
        },
      });
    },
    saveModificadores(datos) {
      this.$alert.alertConfirm({
        action: "actualizar",
        obj: "los modificadores del producto",
        route: "PDV-Productos-updateProducto",
        data: datos,
        onSuccess: () => {
          this.$pgsHelper.writeLog({
            Evento: "PRODUCTO_MODIFICADOR_UPDATE",
            Mensaje: "Modificadores del producto actualizados",
            reference: { id: datos.id, tp: "Producto", al: "Producto General" },
            data: datos
          });
          this.showModalModificador = false;
        },
      });
    },
    toggleModal(open) {
      this.showModal = open;
    },
    async getZonasImpresion() {
      const snapshot =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "/PDV/ZonasImpresion"
        );
      if (snapshot.exists()) {
        this.zonas = [];
        this.zonas.push({ Id: "TICKET-PRINTER", nomb: "Default" });
        Object.keys(snapshot.val()).forEach((id) => {
          const toAdd = snapshot.val()[id];
          if (toAdd) {
            toAdd.Id = id;
            this.zonas.push(toAdd);
          }
        });
      }
    },
    ...mapActions("Categorias", { fetchCategories: "getCategories" }),
    async getCategories() {
      this.Categories = await this.fetchCategories();
    },
    getCategoryById(code) {
      let itemIndex = this.$_.findIndex(this.Categories, { id: code });
      if (itemIndex >= 0) {
        return this.Categories[itemIndex];
      }

      return false;
    },
    getProductoById(code) {
      let itemIndex = this.$_.findIndex(this.global_prod, { id: code });
      if (itemIndex >= 0) {
        return this.$pgsHelper.cloneObj(this.global_prod[itemIndex]);
      }
      return false;
    },
    async getProducts() { },
    async getFamilias() {
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/Productos/Familias"
        );

      this.familias = [];
      this.familias = this.$pgsHelper.ArrayObjectToArray(data.val());
    },
  },
  computed: {
    global_prod() {
      let prod = this.$store.getters.getProductos;
      let origenes = this.$store.getters.getOrigenes;
      let productos = [];
      prod.forEach((element) => {
        element.categoria_name = this.getCategoryById(element.Categoria).Nombre;
        if (this.getCategoryById(element.Categoria).ZImp) {
          element.ZImp = this.$pgsHelper.getById(
            this.zonas,
            "Id",
            this.getCategoryById(element.Categoria).ZImp
          ).nomb;
        } else {
          element.Zimp = "Default";
        }
        if (
          element.Tipo != "Servicio" &&
          element.Tipo != "AYB-Insumo" &&
          element.Tipo != "AYB-Producto" &&
          element.Tipo != "AYB-ICompuesto" &&
          !element.Dlat
        ) {
          let Familia = this.getCategoryById(element.Categoria)
            ? this.getCategoryById(element.Categoria).Familia
            : "";
          element.Familia = this.$pgsHelper.getById(
            this.familias,
            "id",
            Familia
          )
            ? this.$pgsHelper.getById(this.familias, "id", Familia).Nombre
            : "";
          productos.push(element);
        }
        //element.Orden = (element.Orden)?element.Orden:0;
      });

      productos.forEach((producto) => {
        let invData = [];
        let matchCount = 0;
        origenes.forEach((origen, index) => {
          let origenesNames = this.$store.getters.getCentrosConsumo;
          let itemIndex = this.$_.findIndex(origenesNames, {
            id: origen.Origen,
          });
          origen.nombreOrigen = origenesNames[itemIndex]?.Nombre;
          let OrProd = Object.entries(origen.Productos);
          let productMatch = "";
          OrProd.forEach((oProducto) => {
            if (oProducto[0] == producto.id) {
              productMatch = oProducto;
              matchCount++;
              //this.$pgsHelper.log(oProducto[1]);
              /* let pro = producto;
                    let idCompuesto = pro.id+'_'+origen.Origen;
                    pro.Existencia = oProducto[1].Stock;
                    pro.compId = idCompuesto;
                    newProductos.push({id:idCompuesto ,Existencia: oProducto[1].Stock,...producto});*/
            }
          });
          if (productMatch != "") {
            invData.push({
              Origen: origen.Origen,
              Price: productMatch[1],
              NombreOrigen: origen.nombreOrigen,
            });
          }
        });

        producto.existenciaPrecio = invData;
        producto.existenciaCosto = invData;
        producto.existenciaData = invData;
      });

      let data = productos;
      /*let claims = this.$route.params.user.tokenResult.claims;
      if (claims?.Data?.Only?.AYB) {
        data = JSON.parse(JSON.stringify(productos)).filter((prod) => {
          if (prod.Departamentos && prod.Departamentos.includes('Restaurante')) {
            return true;
          } else {
            return false;
          }
        });
      }*/
      let sortReservations = this.$_.orderBy(data, "Orden", "asc");

      return sortReservations;
    },
  },
  watch: {},
  mounted() { },
  created() {
    this.MainDepartamento = localStorage.getItem("selectedDepartment");
    this.getFamilias();
    this.getCategories();
    this.getZonasImpresion();
    //this.getProducts();
  },
};
</script>
